import React from 'react';
import img000 from '../components/images/sample.png';
import img2048 from '../components/images/rmeesho.jpg';

const Events = () => {
    return (
        <>
            <div className="row m-2">
                <img className="img-fluid" src={img2048} alt="meesho" />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h2>Why Register for Meesho?</h2>
                        <p>
                            <strong>Registering on Meesho</strong> allows you to tap into a vast customer base,
                            boost your sales, and expand your business effortlessly.
                        </p>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6">
                        <h2>Essential Details Required:</h2>
                        <ul className="list-group">
                            <li className="list-group-item"><strong>Email ID:</strong> For account creation and communication.</li>
                            <li className="list-group-item"><strong>Contact Number:</strong> Needed for verification and support.</li>
                            <li className="list-group-item"><strong>Pickup Address:</strong> Required for product pickup and delivery.</li>
                            <li className="list-group-item"><strong>Bank Details:</strong> To receive payments directly into your account.</li>
                            <li className="list-group-item"><strong>Product Category:</strong> Helps in listing your products under the appropriate categories.</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">
                        <img className="img-fluid" src={img000} alt="Queryimg" />
                    </div>
                </div>
                <p className="mt-4">
                    <strong>Unlock your potential</strong> with Meesho. Contact E Seller Support for expert assistance.
                </p>
            </div>
        </>
    );
};

export default Events;
